'use client';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

export default function PTEngineCommon() {
    const useRefA = useRef(false);
    const { locale } = useRouter();

    useEffect(() => {
        const initHandleA = () => {
            if (useRefA.current) {
                return;
            }
            useRefA.current = true;
            // 加载 ptengineSrcSecondary
            const pathname = window.location.pathname;

            const SPECIAL_PATHS = ['/us/ecocredits-monthly-madness', '/us', '/us/recreational-activities'];

            // 只有在特殊路径下且 locale 为 'us' 时才加载第二个 ptengine 脚本
            if (SPECIAL_PATHS.includes(pathname) && locale === 'us') {
                const ptengineSrcSecondary = 'https://js.ptengine.com/3dme2grz.js';
                const script = document.createElement('script');
                script.async = true;
                script.src = ptengineSrcSecondary;
                const firstScript = document.getElementsByTagName('script')[0];
                if (firstScript && firstScript.parentNode) {
                    firstScript.parentNode.insertBefore(script, firstScript);
                }
            }
        };
        const initHandle = () => {
            EcoDesignEventsBus.on('UserHasAction-start', () => {
                initHandleA();
            });
            setTimeout(() => {
                initHandleA();
            }, 20 * 1000);
        };
        initHandle();
    }, []);

    return null;
}
